import React, { useState } from 'react';
import { ContentData } from '../data/contentData';

interface AdministrationPageProps {
  content: ContentData;
}

const AdministrationPage: React.FC<AdministrationPageProps> = ({ content }) => {
  const [activeTab, setActiveTab] = useState('governing');

  const governingBody = [
    {
      name: 'মো. আবুল হাসান',
      position: 'চেয়ারম্যান',
      education: 'এম.এসসি, ঢাকা বিশ্ববিদ্যালয়',
      experience: '৩০+ বছর',
      image: '👨‍💼',
      description: 'শিক্ষা মন্ত্রণালয়ের সাবেক সচিব'
    },
    {
      name: 'ড. ফাতেমা বেগম',
      position: 'সদস্য',
      education: 'পিএইচডি, রাজশাহী বিশ্ববিদ্যালয়',
      experience: '২৫+ বছর',
      image: '👩‍💼',
      description: 'শিক্ষা বিশেষজ্ঞ ও গবেষক'
    },
    {
      name: 'প্রফেসর মো. রফিকুল ইসলাম',
      position: 'সদস্য',
      education: 'পিএইচডি, জাহাঙ্গীরনগর বিশ্ববিদ্যালয়',
      experience: '২৮+ বছর',
      image: '👨‍🏫',
      description: 'অধ্যাপক, পদার্থবিজ্ঞান বিভাগ'
    },
    {
      name: 'ড. নাসির উদ্দিন',
      position: 'সদস্য',
      education: 'এম.বি.বি.এস, ঢাকা মেডিকেল কলেজ',
      experience: '২০+ বছর',
      image: '👨‍⚕️',
      description: 'চিকিৎসক ও সমাজসেবী'
    },
    {
      name: 'মো. করিম উদ্দিন',
      position: 'সদস্য',
      education: 'এম.কম, ঢাকা বিশ্ববিদ্যালয়',
      experience: '২২+ বছর',
      image: '👨‍💻',
      description: 'ব্যবসায়ী ও সমাজসেবী'
    }
  ];

  const management = [
    {
      name: 'প্রফেসর ড. মো. আবুল কালাম',
      position: 'অধ্যক্ষ',
      education: 'পিএইচডি, ঢাকা বিশ্ববিদ্যালয়',
      experience: '২৫+ বছর',
      image: '👨‍💼',
      phone: '+৮৮০-২-৯৬৬-০০১৩',
      email: 'principal@rajukcollege.edu.bd',
      description: 'শিক্ষা প্রশাসনে অভিজ্ঞতা সম্পন্ন ব্যক্তিত্ব'
    },
    {
      name: 'মো. রফিকুল ইসলাম',
      position: 'উপাধ্যক্ষ',
      education: 'এম.এসসি, রাজশাহী বিশ্ববিদ্যালয়',
      experience: '২০+ বছর',
      image: '👨‍🏫',
      phone: '+৮৮০-২-৯৬৬-০০১৪',
      email: 'vice-principal@rajukcollege.edu.bd',
      description: 'শিক্ষা ব্যবস্থাপনায় বিশেষজ্ঞ'
    },
    {
      name: 'ড. ফাতেমা খাতুন',
      position: 'শিক্ষা উপদেষ্টা',
      education: 'পিএইচডি, জাহাঙ্গীরনগর বিশ্ববিদ্যালয়',
      experience: '১৫+ বছর',
      image: '👩‍🏫',
      phone: '+৮৮০-২-৯৬৬-০০১৫',
      email: 'advisor@rajukcollege.edu.bd',
      description: 'শিক্ষা নীতি ও পরিকল্পনা বিশেষজ্ঞ'
    }
  ];

  const departments = [
    {
      name: 'শিক্ষা বিভাগ',
      head: 'মো. আব্দুল হামিদ',
      position: 'প্রধান শিক্ষক',
      education: 'এম.এসসি, ঢাকা বিশ্ববিদ্যালয়',
      experience: '১৮+ বছর',
      image: '📚',
      phone: '+৮৮০-২-৯৬৬-০০১৬',
      email: 'academic@rajukcollege.edu.bd',
      staff: 25,
      description: 'শিক্ষা কার্যক্রম পরিচালনা ও উন্নয়ন'
    },
    {
      name: 'ভর্তি বিভাগ',
      head: 'মো. নজরুল ইসলাম',
      position: 'ভর্তি কর্মকর্তা',
      education: 'এম.কম, ঢাকা বিশ্ববিদ্যালয়',
      experience: '১২+ বছর',
      image: '📝',
      phone: '+৮৮০-২-৯৬৬-০০১৭',
      email: 'admission@rajukcollege.edu.bd',
      staff: 8,
      description: 'ভর্তি কার্যক্রম ও শিক্ষার্থী সেবা'
    },
    {
      name: 'অর্থ বিভাগ',
      head: 'মো. করিম উদ্দিন',
      position: 'অর্থ কর্মকর্তা',
      education: 'এম.বি.এ, ঢাকা বিশ্ববিদ্যালয়',
      experience: '১৫+ বছর',
      image: '💰',
      phone: '+৮৮০-২-৯৬৬-০০১৮',
      email: 'finance@rajukcollege.edu.bd',
      staff: 6,
      description: 'অর্থ ব্যবস্থাপনা ও হিসাবরক্ষণ'
    },
    {
      name: 'প্রশাসনিক বিভাগ',
      head: 'মো. আবুল হোসেন',
      position: 'প্রশাসনিক কর্মকর্তা',
      education: 'এম.এ, ঢাকা বিশ্ববিদ্যালয়',
      experience: '১৬+ বছর',
      image: '🏢',
      phone: '+৮৮০-২-৯৬৬-০০১৯',
      email: 'admin@rajukcollege.edu.bd',
      staff: 12,
      description: 'সাধারণ প্রশাসন ও কর্মচারী ব্যবস্থাপনা'
    },
    {
      name: 'প্রযুক্তি বিভাগ',
      head: 'মো. সাকিব আহমেদ',
      position: 'আইটি কর্মকর্তা',
      education: 'এম.এসসি, বুয়েট',
      experience: '১০+ বছর',
      image: '💻',
      phone: '+৮৮০-২-৯৬৬-০০২০',
      email: 'it@rajukcollege.edu.bd',
      staff: 4,
      description: 'প্রযুক্তি সেবা ও ডিজিটালাইজেশন'
    }
  ];

  const faculty = [
    {
      name: 'প্রফেসর ড. মো. আবুল কালাম',
      subject: 'পদার্থবিজ্ঞান',
      qualification: 'পিএইচডি',
      experience: '২৫+ বছর',
      image: '👨‍🏫',
      phone: '+৮৮০-২-৯৬৬-০০২১',
      email: 'abul.kalam@rajukcollege.edu.bd'
    },
    {
      name: 'ড. ফাতেমা বেগম',
      subject: 'রসায়ন',
      qualification: 'পিএইচডি',
      experience: '২০+ বছর',
      image: '👩‍🏫',
      phone: '+৮৮০-২-৯৬৬-০০২২',
      email: 'fatema.begum@rajukcollege.edu.bd'
    },
    {
      name: 'মো. রফিকুল ইসলাম',
      subject: 'গণিত',
      qualification: 'এম.এসসি',
      experience: '১৮+ বছর',
      image: '👨‍🏫',
      phone: '+৮৮০-২-৯৬৬-০০২৩',
      email: 'rafiqul.islam@rajukcollege.edu.bd'
    },
    {
      name: 'ড. নাসির উদ্দিন',
      subject: 'জীববিজ্ঞান',
      qualification: 'পিএইচডি',
      experience: '১৫+ বছর',
      image: '👨‍🏫',
      phone: '+৮৮০-২-৯৬৬-০০২৪',
      email: 'nasir.uddin@rajukcollege.edu.bd'
    },
    {
      name: 'মো. আব্দুল হামিদ',
      subject: 'বাংলা',
      qualification: 'এম.এ',
      experience: '১৬+ বছর',
      image: '👨‍🏫',
      phone: '+৮৮০-২-৯৬৬-০০২৫',
      email: 'abdul.hamid@rajukcollege.edu.bd'
    },
    {
      name: 'ড. রোকসানা খাতুন',
      subject: 'ইংরেজি',
      qualification: 'পিএইচডি',
      experience: '১৪+ বছর',
      image: '👩‍🏫',
      phone: '+৮৮০-২-৯৬৬-০০২৬',
      email: 'roksana.khatun@rajukcollege.edu.bd'
    },
    {
      name: 'মো. করিম উদ্দিন',
      subject: 'ইতিহাস',
      qualification: 'এম.এ',
      experience: '১২+ বছর',
      image: '👨‍🏫',
      phone: '+৮৮০-২-৯৬৬-০০২৭',
      email: 'karim.uddin@rajukcollege.edu.bd'
    },
    {
      name: 'ড. সেলিনা আক্তার',
      subject: 'ভূগোল',
      qualification: 'পিএইচডি',
      experience: '১৩+ বছর',
      image: '👩‍🏫',
      phone: '+৮৮০-২-৯৬৬-০০২৮',
      email: 'selina.akter@rajukcollege.edu.bd'
    },
    {
      name: 'মো. আবুল হোসেন',
      subject: 'ইসলাম শিক্ষা',
      qualification: 'এম.এ',
      experience: '১৫+ বছর',
      image: '👨‍🏫',
      phone: '+৮৮০-২-৯৬৬-০০২৯',
      email: 'abul.hosen@rajukcollege.edu.bd'
    },
    {
      name: 'ড. রুমানা পারভীন',
      subject: 'সমাজবিজ্ঞান',
      qualification: 'পিএইচডি',
      experience: '১১+ বছর',
      image: '👩‍🏫',
      phone: '+৮৮০-২-৯৬৬-০০৩০',
      email: 'rumana.parvin@rajukcollege.edu.bd'
    },
    {
      name: 'মো. নজরুল ইসলাম',
      subject: 'কৃষি বিজ্ঞান',
      qualification: 'এম.এসসি',
      experience: '১৪+ বছর',
      image: '👨‍🏫',
      phone: '+৮৮০-২-৯৬৬-০০৩১',
      email: 'nazrul.islam@rajukcollege.edu.bd'
    },
    {
      name: 'ড. ফারহানা ইয়াসমিন',
      subject: 'মনোবিজ্ঞান',
      qualification: 'পিএইচডি',
      experience: '১০+ বছর',
      image: '👩‍🏫',
      phone: '+৮৮০-২-৯৬৬-০০৩২',
      email: 'farhana.yasmin@rajukcollege.edu.bd'
    },
    {
      name: 'মো. সাকিব আহমেদ',
      subject: 'কম্পিউটার বিজ্ঞান',
      qualification: 'এম.এসসি',
      experience: '৯+ বছর',
      image: '👨‍🏫',
      phone: '+৮৮০-২-৯৬৬-০০৩৩',
      email: 'sakib.ahmed@rajukcollege.edu.bd'
    },
    {
      name: 'ড. নাসিরা খাতুন',
      subject: 'অর্থনীতি',
      qualification: 'পিএইচডি',
      experience: '১৬+ বছর',
      image: '👩‍🏫',
      phone: '+৮৮০-২-৯৬৬-০০৩৪',
      email: 'nasira.khatun@rajukcollege.edu.bd'
    },
    {
      name: 'মো. রহমান আলী',
      subject: 'শারীরিক শিক্ষা',
      qualification: 'এম.এ',
      experience: '১৩+ বছর',
      image: '👨‍🏫',
      phone: '+৮৮০-২-৯৬৬-০০৩৫',
      email: 'rahman.ali@rajukcollege.edu.bd'
    }
  ];

  const tabs = [
    { id: 'governing', label: 'শাসক পরিষদ', icon: '👥' },
    { id: 'management', label: 'প্রশাসন', icon: '👨‍💼' },
    { id: 'departments', label: 'বিভাগসমূহ', icon: '🏢' },
    { id: 'faculty', label: 'শিক্ষকবৃন্দ', icon: '👨‍🏫' }
  ];

  return (
    <div className="py-16 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-4 bangla-font">{content.administration.title}</h1>
          <p className="text-lg text-gray-600 bangla-font">দক্ষ প্রশাসন ও যোগ্য নেতৃত্ব</p>
        </div>

        {/* Tab Navigation */}
        <div className="mb-8">
          <div className="flex flex-wrap justify-center gap-2">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-6 py-3 rounded-lg text-sm font-medium transition-all duration-200 ${
                  activeTab === tab.id
                    ? 'bg-blue-600 text-white shadow-lg'
                    : 'bg-white text-gray-700 hover:bg-blue-50 border border-gray-300'
                }`}
              >
                <span className="mr-2">{tab.icon}</span>
                <span className="bangla-font">{tab.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Governing Body */}
        {activeTab === 'governing' && (
          <div className="space-y-8">
            <div className="bg-white rounded-lg shadow-lg p-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center bangla-font">{content.administration.governingBody}</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {governingBody.map((member, index) => (
                  <div key={index} className="bg-gray-50 rounded-lg p-6 text-center">
                    <div className="text-6xl mb-4">{member.image}</div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2 bangla-font">{member.name}</h3>
                    <p className="text-blue-600 font-medium mb-2 bangla-font">{member.position}</p>
                    <p className="text-sm text-gray-600 mb-1 bangla-font">{member.education}</p>
                    <p className="text-sm text-gray-600 mb-2 bangla-font">অভিজ্ঞতা: {member.experience}</p>
                    <p className="text-xs text-gray-500 bangla-font">{member.description}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Chairman's Message */}
            <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg p-8 text-white">
              <h3 className="text-2xl font-bold mb-4 bangla-font">{content.administration.chairman}</h3>
              <p className="text-lg leading-relaxed bangla-font">{content.administration.chairmanMessage}</p>
            </div>
          </div>
        )}

        {/* Management */}
        {activeTab === 'management' && (
          <div className="space-y-8">
            <div className="bg-white rounded-lg shadow-lg p-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center bangla-font">প্রশাসনিক নেতৃত্ব</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {management.map((member, index) => (
                  <div key={index} className="bg-gray-50 rounded-lg p-6 text-center">
                    <div className="text-6xl mb-4">{member.image}</div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2 bangla-font">{member.name}</h3>
                    <p className="text-blue-600 font-medium mb-2 bangla-font">{member.position}</p>
                    <p className="text-sm text-gray-600 mb-1 bangla-font">{member.education}</p>
                    <p className="text-sm text-gray-600 mb-2 bangla-font">অভিজ্ঞতা: {member.experience}</p>
                    <p className="text-xs text-gray-500 mb-4 bangla-font">{member.description}</p>
                    <div className="space-y-1">
                      <p className="text-xs text-gray-600 bangla-font">ফোন: {member.phone}</p>
                      <p className="text-xs text-gray-600 bangla-font">ইমেইল: {member.email}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Principal's Message */}
            <div className="bg-gradient-to-r from-green-600 to-blue-600 rounded-lg p-8 text-white">
              <h3 className="text-2xl font-bold mb-4 bangla-font">{content.administration.principal}</h3>
              <p className="text-lg leading-relaxed bangla-font">{content.administration.principalMessage}</p>
            </div>
          </div>
        )}

        {/* Departments */}
        {activeTab === 'departments' && (
          <div className="space-y-8">
            <div className="bg-white rounded-lg shadow-lg p-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center bangla-font">{content.administration.faculty}</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {departments.map((dept, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow">
                    <div className="flex items-start space-x-4">
                      <div className="text-4xl">{dept.image}</div>
                      <div className="flex-1">
                        <h3 className="text-xl font-semibold text-gray-900 mb-2 bangla-font">{dept.name}</h3>
                        <p className="text-blue-600 font-medium mb-2 bangla-font">{dept.head} - {dept.position}</p>
                        <p className="text-sm text-gray-600 mb-1 bangla-font">{dept.education}</p>
                        <p className="text-sm text-gray-600 mb-2 bangla-font">অভিজ্ঞতা: {dept.experience}</p>
                        <p className="text-xs text-gray-500 mb-3 bangla-font">{dept.description}</p>
                        <div className="space-y-1">
                          <p className="text-xs text-gray-600 bangla-font">ফোন: {dept.phone}</p>
                          <p className="text-xs text-gray-600 bangla-font">ইমেইল: {dept.email}</p>
                          <p className="text-xs text-gray-600 bangla-font">কর্মচারী: {dept.staff} জন</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Faculty */}
        {activeTab === 'faculty' && (
          <div className="space-y-8">
            <div className="bg-white rounded-lg shadow-lg p-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center bangla-font">শিক্ষকবৃন্দ</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {faculty.map((teacher, index) => (
                  <div key={index} className="bg-gray-50 rounded-lg p-6 text-center">
                    <div className="text-5xl mb-4">{teacher.image}</div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2 bangla-font">{teacher.name}</h3>
                    <p className="text-blue-600 font-medium mb-2 bangla-font">{teacher.subject}</p>
                    <p className="text-sm text-gray-600 mb-1 bangla-font">{teacher.qualification}</p>
                    <p className="text-sm text-gray-600 mb-3 bangla-font">অভিজ্ঞতা: {teacher.experience}</p>
                    <div className="space-y-1">
                      <p className="text-xs text-gray-600 bangla-font">ফোন: {teacher.phone}</p>
                      <p className="text-xs text-gray-600 bangla-font">ইমেইল: {teacher.email}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Faculty Statistics */}
            <div className="bg-white rounded-lg shadow-lg p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center bangla-font">শিক্ষক পরিসংখ্যান</h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
                <div>
                  <div className="text-3xl font-bold text-blue-600 mb-2">{faculty.length}</div>
                  <div className="text-gray-600 bangla-font">মোট শিক্ষক</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-green-600 mb-2">৮</div>
                  <div className="text-gray-600 bangla-font">পিএইচডি</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-purple-600 mb-2">৪</div>
                  <div className="text-gray-600 bangla-font">এম.এসসি</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-orange-600 mb-2">১৪+</div>
                  <div className="text-gray-600 bangla-font">গড় অভিজ্ঞতা</div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Contact Information */}
        <div className="mt-16 bg-white rounded-lg shadow-lg p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center bangla-font">যোগাযোগের তথ্য</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-4xl mb-4">📞</div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2 bangla-font">ফোন</h3>
              <p className="text-gray-600 bangla-font">+৮৮০-২-৯৬৬-০০১১</p>
            </div>
            <div>
              <div className="text-4xl mb-4">✉️</div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2 bangla-font">ইমেইল</h3>
              <p className="text-gray-600 bangla-font">info@rajukcollege.edu.bd</p>
            </div>
            <div>
              <div className="text-4xl mb-4">🕒</div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2 bangla-font">অফিসের সময়</h3>
              <p className="text-gray-600 bangla-font">সকাল ৮:০০ - বিকাল ৫:০০</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdministrationPage;
